import React from "react";
import Header from "../../../../Components/Header";
import { Helmet } from "react-helmet";
import AddNewCostCenterAllocation from "./AddNewCostCenterAllocation";

function NewCostCenterAllocation() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>New Cost Center Allocation</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column "
        style={{ flexGrow: "1" }}
      >
        <AddNewCostCenterAllocation />
      </div>
    </div>
  );
}

export default NewCostCenterAllocation;